/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Xaero Zero - xaerozero@icloud.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { User } from './user';
import { ModuleType } from './enums/module.type';

export class HistoryEmail {
  ID: string;
  SUBJECT: string;
  CONTENT: string;
  DATE: Date;
  USER: User;
  MODULE_TYPE: ModuleType;

  constructor(value: any = {}) {
    Object.assign(this, value);

    if(value.USER)
      this.USER = User.parse(value.USER);
  }

  static parseArray(json: any[]): HistoryEmail[] {
    const arr = [];

    if (json)
      for (const j of json)
        if (j)
          arr.push(new HistoryEmail(j));

    return arr;
  }
}
